const { getElement } = window.BAO.Utils

class ProductDetail extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.cloneContent()
    this.measureStickyBar()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)
    this.measureStickyBar = this.measureStickyBar.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })

    const stickyEl = this.els.sticky?.element
    if (stickyEl && 'ResizeObserver' in window) {
      this.stickyBarObserver = new ResizeObserver(this.measureStickyBar)
      this.stickyBarObserver.observe(stickyEl)
    }
  }

  measureStickyBar () {
    const stickyEl = this.els.sticky?.element
    const height = stickyEl ? `${stickyEl.offsetHeight}px` : '0px'
    const root = document.documentElement

    if (root.style.getPropertyValue('--PrdStickyBar_Height') === height) return

    root.style.setProperty('--PrdStickyBar_Height', height)
  }

  cloneContent () {
    if (!this.els?.clone?.exists) return
    this.els.clone.elements.forEach(cloneEl => {
      if (!cloneEl.dataset?.cloneIdentifier) return

      const elementToClone = getElement(cloneEl.dataset.cloneIdentifier, {
        context: this,
      })
      if (!elementToClone) return
      cloneEl.innerHTML = elementToClone.innerHTML
    })
  }

  onScroll () {
    this.lastKnownY = window.scrollY
    const stickyEl = this.els.sticky?.element
    if (!stickyEl) return

    if (this.lastKnownY >= 400) {
      stickyEl.classList.add('prd-Detail_Blocks-stickyScrolled')
    } else {
      stickyEl.classList.remove('prd-Detail_Blocks-stickyScrolled')
    }
  }
}

if (!customElements.get('product-detail')) {
  customElements.define('product-detail', ProductDetail)
}
